"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatString = void 0;
const formatString = (str) => Number(str.replace(',', '.'));
exports.formatString = formatString;
//# sourceMappingURL=basket-quick-bet.utils.js.map